import { viessmannShop } from '@common';
import { AppEnvironmentConfig } from './environment.model';

export const environment: AppEnvironmentConfig = {
  production: true,
  sentry: false,
  AUTH_REDIRECT_LOCAL: false,
  env: 'staging',
  reduxDevTool: true,
  registerUrl:
    'https://account-staging.viessmann-climatesolutions.com/register?hideNoCompanyNumberOption=true&redirect=',
  accountApiUrl: 'https://account-staging.viessmann-climatesolutions.com',
  headerModuleApiUrl: 'https://api-staging.viessmann-climatesolutions.com',
  heatingSystemsUrl: 'https://systems-overview.viessmann-climatesolutions.com/',
  viessmannShop: 'https://shop-stage.viessmann-climatesolutions.com/',
  buyRepeaterLink: `${viessmannShop}details/ZK05390?searchTerm=Funk-repeater&page=0&selectedDetailsTab=parts_list&crumbs=WkswNTM5MA%3D%3D`,
  csrfTokenConfig: {
    appId: 'vitoguide',
    localStorageKey: 'csrf_token',
  },
  clientConfig: {
    withCredentials: true,
    baseUrl: 'https://api-staging.viessmann-climatesolutions.com/',
    diagStackPoolManager: 'https://diagstack-pool-manager-staging.viessmann-platform.io',
    version: 'v2',
  },
  authConfig: {
    logoutRedirectUri: 'https://viguide-release-preview.viessmann-climatesolutions.com/',
  },
  oAuthConfig: {
    issuer: 'https://iaml2.viessmann-climatesolutions.com',
    loginUrl: 'https://iaml2.viessmann-climatesolutions.com/idp/v3/authorize',
    logoutUrl: 'https://iaml2.viessmann-climatesolutions.com/idp/v3/sso/logout',
    tokenEndpoint: 'https://iaml2.viessmann-climatesolutions.com/idp/v3/token',
    userinfoEndpoint: 'https://iaml2.viessmann-climatesolutions.com/idp/v2/tokeninfo',
     redirectUri: 'https://viguide-release-preview.viessmann-climatesolutions.com/',
    clientId: '4ff39d4f3ac9b75523c82b83448f0258',
    postLogoutRedirectUri: '',
    responseType: 'code',
    scope: 'Internal offline_access',
    oidc: false,
    clockSkewInSec: 0,
    customQueryParams: {
      RegistrationLink:
        'https://account-staging.viessmann-climatesolutions.com/register?redirect=https://viguide-staging.viessmann-climatesolutions.com/home',
      ForgotUsername: 'https://account-staging.viessmann-climatesolutions.com/forgot-username',
    },
  },
  http: {
    baseUrl: 'https://api-staging.viessmann-climatesolutions.com/vitoguide/',
    everestBaseUrl: 'https://api-staging.viessmann-climatesolutions.com/',
  },
  statusPageAppId: 'gghm8vrp33mm',
  FEATURE: {
    SERVICE_APP_ENABLED: true,
    DOWNTIME_NOTIFICATION_ENABLED: false,
  },
  appId: 'd2d31061-f6af-492b-90f3-7ca3c41852a7',
  xOtaId: '429872e8-9933-469f-b372-7f2df436076d',
  legalDocuments: {
    appId: '81bae46d-30c8-4b6e-bb40-de5844aebf65',
    EUDataUsageAgreementAppId: '22c057a2-181d-443e-8f5a-3b0cd12feb23',
  },
  phraseappProjects: {
    viCareId: 'd9e9e9edc24cd5e98adee563deea07c3',
  },
  appInsights: {
    config: {
      connectionString:
        'InstrumentationKey=170006f2-1928-41ee-9acb-105e3222a248;IngestionEndpoint=https://northeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://northeurope.livediagnostics.monitor.azure.com/',
      enableAutoRouteTracking: false, // option to log all route changes
    },
  },
  externalWhitelist: false,
};
